import { buildGroupPage } from "discourse/routes/group-activity-posts";
export default buildGroupPage("mentions");